/**
 * Leasing Admin — boundary contract schemas (Phase 5).
 *
 * Owned here, not beside the route: `apps/api/src/routes/admin/leasing-admin.schemas.ts`
 * imports and re-exports this to register the routes, and
 * `apps/landlord/src/lib/leasing.api.ts` derives its `SweepResult` type from the same
 * object. See packages/api-types/README.md.
 *
 * Covers:
 *   POST /admin/api/leasing/retention/sweep
 */
import { z } from 'zod';
export const SweepResultSchema = z.object({
    dryRun: z.boolean(),
    sweptRunId: z.uuid(),
    attachmentsDisposed: z.number().int().nonnegative(),
    bytesFreed: z.number().nonnegative(),
    attachmentsErrored: z.number().int().nonnegative(),
    leadsDisposed: z.number().int().nonnegative(),
    leadsErrored: z.number().int().nonnegative(),
});
//# sourceMappingURL=admin.js.map